import { useFormikContext } from "formik"

import { DetailedProductGroups } from "../../priceListTypes"
import { AdjustPricesFormValues } from "./adjustPricesLib"

export function useScopeSelection(productGroups: ReadonlyArray<DetailedProductGroups>) {
    const { values, setFieldValue } = useFormikContext<AdjustPricesFormValues>()

    const selected = new Set(values.productGroupIds)
    const allIds = productGroups.map((group) => group.id)
    const isEverythingSelected = allIds.length > 0 && allIds.every((id) => selected.has(id))

    const toggle = (groupId: number) => {
        const next = selected.has(groupId)
            ? values.productGroupIds.filter((id) => id !== groupId)
            : [...values.productGroupIds, groupId]

        setFieldValue("productGroupIds", next)
    }

    const toggleAll = () => {
        setFieldValue("productGroupIds", isEverythingSelected ? [] : allIds)
    }

    return { selected, isEverythingSelected, toggle, toggleAll }
}
